import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";

import LoginView from "./views/LoginView.vue";
import LogoutView from "./views/LogoutView.vue";
import NewTrip from "../src/components/NewTrip/NewTrip.vue";
import NewTripSelectPerson from "../src/components/NewTrip/SelectPerson.vue";
import NewTripSelectDelegationOrder from "../src/components/NewTrip/SelectDelegationOrder.vue";
import NotFoundView from "./views/404View";

import ClearWnb from "../src/components/Settings/ClearWnb.vue";

const NewUserForm = () => import(/* webpackChunkName: "settings" */ "../src/components/Settings/Users/NewUserForm.vue");

const SettingsMenu = () => import("./views/settings/SettingsMenuView");

Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  if (typeof to.meta.isAuthenticateRequired !== "undefined" && to.meta.isAuthenticateRequired === false) {
    next();
    return;
  }

  //next({path: '/login/' + encodeURIComponent(urlHelper.pathname.substring(1)), replace: true});
  next({
    path: "/login/" + encodeURIComponent(to.path.substring(1)),
    query: to.query,
    replace: true
  });
};

const ifAuthenticatedAdminContext = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next({
      path: "/login/" + encodeURIComponent(to.path.substring(1)),
      query: to.query,
      replace: true
    });
    return;
  }

  if (!store.getters.isAdmin) {
    store.dispatch("alertDialog", {
      content: "Dostęp do tej strony możliwy jest jedynie w kontekście administracyjnym!",
      title: "Brak uprawnień"
    });
    return;
  }
  next();
};

const router = new Router({
  mode: "history",
  hashbang: true,
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/profile/password-forgotten",
      component: () => import("./views/profile/PasswordForgottenView"),
      meta: {
        isAuthenticateRequired: false
      }
    },
    {
      path: "/action-by-link",
      component: () => import("./views/action-by-link/ActionByLinkView"),
      meta: {
        isAuthenticateRequired: false
      }
    },
    {
      path: "/action-by-link/:token",
      component: () => import("./views/action-by-link/ActionByLinkView"),
      meta: {
        isAuthenticateRequired: false
      }
    },
    {
      path: "/action-by-link/delegation/decision/:token",
      component: () => import("./views/action-by-link/delegation/ActionByLinkDelegationDecisionView"),
      meta: {
        isAuthenticateRequired: false
      }
    },
    {
      path: "/action-by-link/delegationOrder/decision/:token",
      component: () => import("./views/action-by-link/delegation-order/ActionByLinkDelegationOrderDecisionView"),
      meta: {
        isAuthenticateRequired: false
      }
    },
    {
      path: "/action-by-link/user/passwordChange/:token",
      component: () => import("./views/action-by-link/user/ActionByLinkUserPasswordChangeView"),
      meta: {
        isAuthenticateRequired: false
      }
    },
    {
      path: "/password-expired",
      component: () => import("./views/PasswordExpired"),
      meta: {
        isAuthenticateRequired: false
      }
    },
    {
      path: "/delegation-info/vehicle",
      component: () => import("./views/delegation-info/DelegationInfoVehicleView")
    },
    {
      path: "/invoices",
      component: () => import("./views/invoices/InvoicesView")
    },
    {
      path: "/invoices/details/:id",
      component: () => import("./views/invoices/InvoicesDetailsView")
    },

    {
      path: "/booking",
      component: () => import("./views/booking/BookingView")
    },
    {
      path: "/booking/flight",
      component: () => import("./views/booking/BookingFlightView"),
      meta: {
        isFlightBookingModuleRequired: true
      }
    },
    {
      path: "/booking/flight/detail/:id",
      component: () => import("./views/booking/BookingFlightDetailView"),
      meta: {
        isFlightBookingModuleRequired: true
      }
    },
    {
      path: "/booking/other/detail/:id",
      component: () => import("./views/booking/BookingOtherDetailView")
    },
    {
      path: "/booking/rail",
      component: () => import("./views/booking/BookingRailView"),
      meta: {
        isAllBookingModuleRequired: true
      }
    },
    {
      path: "/booking/hotel",
      component: () => import("./views/booking/BookingHotelView"),
      meta: {
        isAllBookingModuleRequired: true
      }
    },
    {
      path: "/booking/other",
      component: () => import("./views/booking/BookingOtherView"),
      meta: {
        isFlightBookingModuleRequired: true
      }
    },
    {
      path: "/booking/mapping",
      component: () => import("./views/booking/BookingMappingView")
    },
    {
      path: "/booking/report",
      component: () => import("./views/booking/BookingReportView"),
      meta: {
        isFlightBookingModuleRequired: true
      }
    },
    {
      path: "/booking/report/monthly",
      component: () => import("./views/booking/report/BookingReportMonthlyView"),
      meta: {
        isFlightBookingModuleRequired: true
      }
    },
    {
      path: "/booking/report/organization-unit",
      component: () => import("./views/booking/report/BookingReportOrganizationUnitView"),
      meta: {
        isFlightBookingModuleRequired: true
      }
    },
    {
      path: "/booking/report/passenger",
      component: () => import("./views/booking/report/BookingReportPassengerView")
    },
    {
      path: "/booking/report/airline",
      component: () => import("./views/booking/report/BookingReportAirlineView")
    },
    {
      path: "/booking/report/seat-class",
      component: () => import("./views/booking/report/BookingReportSeatClassView")
    },
    {
      path: "/booking/report/domestic-foreign",
      component: () => import("./views/booking/report/BookingReportDomesticForeignView")
    },
    {
      path: "/booking/report/budget",
      component: () => import("./views/booking/report/BookingReportBudgetUtilizationView")
    },
    {
      path: "/booking/report/budget/new",
      component: () => import("./views/booking/report/BookingReportBudgetUtilizationNewView")
    },
    {
      path: "/booking/report/budget/edit/:id",
      component: () => import("./views/booking/report/BookingReportBudgetUtilizationEditView")
    },

    {
      path: "/login",
      component: LoginView,
      meta: {
        isAuthenticateRequired: false
      }
    },
    {
      path: "/login/:address(.*)",
      component: LoginView,
      meta: {
        isAuthenticateRequired: false
      }
    },
    {
      path: "/logout",
      component: LogoutView,
      meta: {
        isAuthenticateRequired: false
      }
    },
    {
      path: "/login-as",
      component: () => import("./views/LoginAsView")
    },

    /* ------------------------------------- DO REFACTORA NA POZNIEJ -------------------------------------------------------------*/
    {
      path: "/new-trip",
      component: NewTrip,
      children: [
        {
          path: "",
          component: NewTripSelectPerson
        },
        {
          path: "select-service",
          component: NewTripSelectDelegationOrder
        }
      ]
    },
    {
      path: "/",
      component: NewTrip,
      children: [
        {
          path: "",
          component: NewTripSelectPerson
        }
      ]
    },
    /* ------------------------------------- DO REFACTORA NA POZNIEJ -------------------------------------------------------------*/

    {
      path: "/delegation-advance",
      component: () => import("./views/delegation-advance/DelegationAdvanceView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation-order",
      component: () => import("./views/delegation-order/DelegationOrderView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation-order/new",
      component: () => import("./views/delegation-order/DelegationOrderNewView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation-order/edit/:id",
      component: () => import("./views/delegation-order/DelegationOrderEditView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation-order/readonly/:id",
      component: () => import("./views/delegation-order/DelegationOrderReadonlyView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation-order/decision/:id",
      component: () => import("./views/delegation-order/DelegationOrderDecisionView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },

    {
      path: "/delegation",
      component: () => import("./views/delegation/DelegationView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation/start",
      component: () => import("./views/delegation/DelegationStartView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation/start-choose-order",
      component: () => import("./views/delegation/DelegationStartChooseOrderView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation/new",
      component: () => import("./views/delegation/DelegationNewView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation/edit/:id",
      component: () => import("./views/delegation/DelegationEditView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation/readonly/:id",
      component: () => import("./views/delegation/DelegationReadonlyView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation/decision/:id",
      component: () => import("./views/delegation/DelegationDecisionView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation/new-from-order/:orderId",
      component: () => import("./views/delegation/DelegationNewFromOrderView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },

    {
      path: "/substitutes",
      component: () => import("./views/substitutes/SubstitutesView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/substitutes/deputyAuth",
      component: () => import("./views/substitutes/SubstitutesDeputyAuthView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },

    {
      path: "/delegation-info",
      component: () => import("./views/delegation-info/DelegationInfoView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation-info/delegation-task",
      component: () => import("./views/delegation-info/DelegationInfoDelegationTaskView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation-info/delegation-rate",
      component: () => import("./views/delegation-info/DelegationInfoDelegationRateView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation-info/exchange-rate",
      component: () => import("./views/delegation-info/DelegationInfoExchangeRateView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/delegation-info/:alias(.*)",
      component: () => import("./views/delegation-info/DelegationInfoCustomWebpageView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },

    /**-----------------------------SEPARATED CHUNK SETTINGS ----------------------------------------------------------------------*/

    {
      path: "/settings/",
      component: SettingsMenu,
      children: [
        {
          path: "users",
          component: () => import("./views/settings/users/SettingsUsersView")
        },
        {
          path: "cost-centre",
          component: () => import("./views/settings/cost-centre/SettingsCostCentreView")
        },
        {
          path: "cost-centre/users",
          component: () => import("./views/settings/cost-centre/SettingsCostCentreUsersView")
        },
        {
          path: "cost-centre/budget",
          component: () => import("./views/settings/cost-centre/SettingsCostCentreBudgetView")
        },
        {
          path: "user-substitute",
          component: () => import("./views/settings/SettingsUserSubstituteView")
        },
        {
          path: "role",
          component: () => import("./views/settings/role/SettingsRoleView")
        },
        {
          path: "role/deputy-auth",
          component: () => import("./views/settings/role/SettingsRoleDeputyAuthView")
        },
        {
          path: "role/mapping",
          component: () => import("./views/settings/role/mapping/SettingsRoleMappingView")
        },
        {
          path: "role/default",
          component: () => import("./views/settings/role/SettingsRoleDefaultView")
        },
        {
          path: "system-settings",
          component: () => import("./views/settings/system-settings/SettingsSystemSettings")
        },
        {
          path: "system-settings/document-number-template/new",
          component: () => import("./views/settings/system-settings/document-number-template/SettingsSystemSettingsDocumentNumberTemplateNewView")
        },
        {
          path: "system-settings/document-number-template/edit/:id",
          component: () => import("./views/settings/system-settings/document-number-template/SettingsSystemSettingsDocumentNumberTemplateEditView")
        },
        {
          path: "system-settings/document-number-template",
          component: () => import("./views/settings/system-settings/document-number-template/SettingsSystemSettingsDocumentNumberTemplateView")
        },
        {
          path: "delegation-rate",
          component: () => import("./views/settings/delegation-rate/SettingsDelegationRateView")
        },
        {
          path: "delegation-rate/mileage",
          component: () => import("./views/settings/delegation-rate/SettingsDelegationRateMileageView")
        },
        {
          path: "delegation-rate/custom",
          component: () => import("./views/settings/delegation-rate/SettingsDelegationRateCustom")
        },
        {
          path: "delegation-rate/group",
          component: () => import("./views/settings/delegation-rate/SettingsDelegationRateGroup")
        },
        {
          path: "trip-policy",
          component: () => import("./views/settings/SettingsTripPolicyView")
        },
        {
          path: "custom-webpage",
          component: () => import("./views/settings/SettingsCustomWebpageView")
        },
        {
          path: "custom-webpage/edit/:id",
          component: () => import("./views/settings/SettingsCustomWebpageEditView")
        },
        {
          path: "delegation-task",
          component: () => import("./views/settings/SettingsDelegationTaskView")
        },
        {
          path: "external-company",
          component: () => import("./views/settings/SettingsExternalCompanyView")
        },
        {
          path: "project",
          component: () => import("./views/settings/SettingsProjectView")
        },
        {
          path: "vehicles",
          component: () => import("./views/settings/SettingsVehiclesView")
        },
        {
          path: "logs",
          component: () => import("./views/settings/SettingsLogsView")
        },
        {
          path: "organizational-structure",
          component: () => import("./views/settings/organizational-structure/SettingsOrganizationalStructureView")
        },
        {
          path: "organizational-structure/users",
          component: () => import("./views/settings/organizational-structure/SettingsOrganizationalStructureUsersView")
        },
        {
          path: "workflow",
          component: () => import("./views/settings/workflow/SettingsWorkflowView")
        },
        {
          path: "travel-service",
          component: () => import("./views/settings/travel-service/SettingsTravelServiceView")
        },
        {
          path: "travel-service/additional-parameters",
          component: () => import("./views/settings/travel-service/SettingsTravelServiceAdditionalParametersView")
        },
        {
          path: "travel-service/mail-subject",
          component: () => import("./views/settings/travel-service/SettingsTravelServiceMailSubjectView")
        },
        {
          path: "travel-service/additional-settings",
          component: () => import("./views/settings/travel-service/SettingsTravelServiceAdditionalSettingsView")
        }
      ]
    },
    {
      path: "/settings/users/new",
      component: NewUserForm
    },
    {
      path: "/settings/users/edit/:id/basic",
      component: () => import("./views/settings/users/edit/SettingsUserEditBasicView")
    },
    {
      path: "/settings/users/edit/:id/cost-centre",
      component: () => import("./views/settings/users/edit/SettingsUserEditCostCentreView")
    },
    {
      path: "/settings/users/edit/:id/delegation",
      component: () => import("./views/settings/users/edit/SettingsUserEditDelegationView")
    },
    {
      path: "/settings/users/edit/:id/roles-and-permissions",
      component: () => import("./views/settings/users/edit/SettingsUserEditRolesAndPermissionsView")
    },
    {
      path: "/settings/users/edit/:id/additional-data",
      component: () => import("./views/settings/users/edit/SettingsUserEditAdditionalDataView")
    },
    {
      path: "/settings",
      component: () => import("./views/settings/users/SettingsUsersView")
    },
    {
      path: "/settings/role/new",
      component: () => import("./views/settings/role/SettingsRoleNewView")
    }, //+
    {
      path: "/settings/role/edit/:id",
      component: () => import("./views/settings/role/SettingsRoleEditView")
    }, //+
    {
      path: "/settings/role/edit-users/:id",
      component: () => import("./views/settings/role/SettingsRoleEditUsersView")
    }, //+
    {
      path: "/settings/role/mapping/new",
      component: () => import("./views/settings/role/mapping/SettingsRoleMappingNewView")
    },
    {
      path: "/settings/role/mapping/edit/:name",
      component: () => import("./views/settings/role/mapping/SettingsRoleMappingEditView")
    },

    /**-----------------------------SEPARATED CHUNK SETTINGS ----------------------------------------------------------------------------------------*/

    {
      path: "/profile/my-profile",
      component: () => import("./views/profile/MyProfileView")
    },

    { path: "/clearwnb", component: ClearWnb },

    {
      path: "/travel-service/pkp-intercity",
      component: () => import("./views/travel-service/TravelServicePKPIntercityView"),
      meta: {
        isTravelServiceModuleRequired: true
      }
    },
    {
      path: "/travel-service/new",
      component: () => import("./views/travel-service/TravelServiceNewView"),
      meta: {
        isTravelServiceModuleRequired: true
      }
    },
    {
      path: "/travel-service/choose-offer/:id",
      component: () => import("./views/travel-service/TravelServiceChoseOfferView"),
      meta: {
        isTravelServiceModuleRequired: true
      }
    },
    {
      path: "/travel-service/edit/:id",
      component: () => import("./views/travel-service/TravelServiceEditView"),
      meta: {
        isTravelServiceModuleRequired: true
      }
    },
    {
      path: "/travel-service",
      component: () => import("./views/travel-service/TravelServiceView"),
      meta: {
        isTravelServiceModuleRequired: true
      }
    },
    {
      path: "/travel-service/approval/:id",
      component: () => import("./views/travel-service/TravelServiceApprovalView"),
      meta: {
        isTravelServiceModuleRequired: true
      }
    },
    {
      path: "/travel-service/booked/:id",
      component: () => import("./views/travel-service/TravelServiceBookedView"),
      meta: {
        isTravelServiceModuleRequired: true
      }
    },
    {
      path: "/travel-service/item-details/:id",
      component: () => import("./views/travel-service/TravelServiceItemDetailsView"),
      meta: {
        isTravelServiceModuleRequired: true
      }
    },

    {
      path: "/admin/travel-service/all",
      component: () => import("./views/admin/travel-service/AdminTravelServiceAllView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/travel-service/item/edit/:id",
      component: () => import("./views/admin/travel-service/AdminTravelServiceItemEditView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/travel-service/item/readonly/:id",
      component: () => import("./views/admin/travel-service/AdminTravelServiceItemReadonlyView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/travel-service/by-type/:type",
      component: () => import("./views/admin/travel-service/AdminTravelServiceByTypeView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/travel-service/edit/:id",
      component: () => import("./views/admin/travel-service/AdminTravelServiceEditView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/users",
      component: () => import("./views/admin/users/AdminUsersView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/users/edit/:id/basic",
      component: () => import("./views/admin/users/AdminUsersEditBasicView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/users/edit/:id/roles-and-permissions",
      component: () => import("./views/admin/users/AdminUsersEditRolesAndPermissionView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/travel-service/add-booking/:id",
      component: () => import("./views/admin/travel-service/AdminTravelServiceAddBookingView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/users/new",
      component: () => import("./views/admin/users/AdminUsersNewView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/mailing",
      component: () => import("./views/admin/AdminMailingView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/companies",
      component: () => import("./views/admin/AdminCompaniesView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/admin/system-settings",
      component: () => import("./views/admin/AdminSystemSettingsView"),
      beforeEnter: ifAuthenticatedAdminContext
    },
    {
      path: "/report",
      component: () => import("./views/report/ReportView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    {
      path: "/optima",
      component: () => import("./views/optima/OptimaView"),
      meta: {
        isDelegationModuleRequired: true,
        isOptimaModuleRequired: true
      }
    },
    {
      path: "/optima/settings/category",
      component: () => import("./views/optima/OptimaSettingsCategoryView"),
      meta: {
        isDelegationModuleRequired: true,
        isOptimaModuleRequired: true
      }
    },
    {
      path: "/optima/settings/contractor",
      component: () => import("./views/optima/OptimaSettingsContractorView"),
      meta: {
        isDelegationModuleRequired: true,
        isOptimaModuleRequired: true
      }
    },
    {
      path: "/optima/settings/employee",
      component: () => import("./views/optima/OptimaSettingsEmployeeView"),
      meta: {
        isDelegationModuleRequired: true,
        isOptimaModuleRequired: true
      }
    },
    {
      path: "/report/new",
      component: () => import("./views/report/ReportNewView"),
      meta: {
        isDelegationModuleRequired: true
      }
    },
    { path: "*", component: NotFoundView }
  ]
});

router.beforeEach(ifAuthenticated);

//todo per module guard if needed
router.beforeResolve((to, from, next) => {
  if (
    (typeof to.meta.isAllBookingModuleRequired !== "undefined" &&
      to.meta.isAllBookingModuleRequired === true &&
      store.getters["userProperties"] !== null &&
      store.getters["userProperties"].system_settings.is_module_all_bookings_enabled !== 2) ||
    (typeof to.meta.isFlightBookingModuleRequired !== "undefined" &&
      to.meta.isFlightBookingModuleRequired === true &&
      store.getters["userProperties"] !== null &&
      store.getters["userProperties"].system_settings.is_module_flight_bookings_enabled === 1 &&
      store.getters["userProperties"].system_settings.is_module_all_bookings_enabled === 1) ||
    (typeof to.meta.isOptimaModuleRequired !== "undefined" &&
      to.meta.isOptimaModuleRequired === true &&
      store.getters["userProperties"] !== null &&
      store.getters["userProperties"].system_settings.is_module_optima_enabled !== 2) ||
    (typeof to.meta.isDelegationModuleRequired !== "undefined" &&
      to.meta.isDelegationModuleRequired === true &&
      store.getters["userProperties"] !== null &&
      store.getters["userProperties"].system_settings.is_module_delegation_enabled !== 2) ||
    (typeof to.meta.isTravelServiceModuleRequired !== "undefined" &&
      to.meta.isTravelServiceModuleRequired === true &&
      store.getters["userProperties"] !== null &&
      store.getters["userProperties"].system_settings.is_module_travel_service_enabled !== 2)
  ) {
    next("/module-not-available-in-that-company");
  } else {
    next();
  }
});

export default router;
